module.exports = __webpack_public_path__ + "static/media/new order.2aad1607.png";